import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.css'],
})
export class DriverComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
